$(document).ready(function () {
	// Header & Nav + responsive
	$('.desktop-nav li').click(function () {
		$(this).addClass('active')
		$(this).parent().children('li').not(this).removeClass('active')
	})

	$('.mobile-nav-icon').click(function () {
		$('.header__mob-nav__holder').css('display', 'flex')
	})

	$('.header__mobile-close').click(function () {
		$('.header__mob-nav__holder').hide()
	})

	$('.header__mobile-logo a').click(function () {
		$('.header__mob-nav__holder').hide()
	})

	$('.header__mob-nav__holder li').click(function () {
		$('.header__mob-nav__holder').hide()
	})
})

function toggleFpLoginDrop(event) {
	event.stopPropagation()
	var isOpen = $('.fp-login__drop').toggleClass('show').hasClass('show')
	$('.fp-login__drop').attr('aria-hidden', !isOpen)
	$('#fpLoginBtn').attr('aria-expanded', isOpen)
	$('#fpMobLoginBackdrop').toggleClass('open')
}

$(document).on('click', function () {
	$('.fp-login__drop').removeClass('show').attr('aria-hidden', true)
	$('#fpLoginBtn').attr('aria-expanded', false)
	$('#fpMobLoginBackdrop').removeClass('open')
})

function fpOpenMobMenu() {
	$('#fpMobMenu').toggleClass('open')
}

function fpCloseMobMenu() {
	$('#fpMobMenu').removeClass('open')
}

function fpConfirmLogout() {
	$('#fpUbModal').addClass('open')
}

function fpCloseLogoutModal() {
	$('#fpUbModal').removeClass('open')
}

function fpDoLogout() {
	$('#fpUbModal').removeClass('open')
	$('.fp-login__guest').prop('hidden', false)
	$('#headerClaim').removeClass('hide')
	$('.fp-header__ikona').removeClass('show')
	$('#fpLoginUser').prop('hidden', true)
	$('#fpToastContainer2').addClass('show')
	setTimeout(function () {
		$('#fpToastContainer2').removeClass('show')
	}, 3000)
}

function fpDoLogin() {
	$('.fp-login__guest').prop('hidden', true)
	$('#fpLoginUser').prop('hidden', false)
	$('#headerClaim').addClass('hide')
	$('.fp-header__ikona').addClass('show')
	$('#fpToastContainer').addClass('show')
	setTimeout(function () {
		$('#fpToastContainer').removeClass('show')
	}, 3000)
}

function fpDoLoginFirma() {
	$('#fpToastContainer3').addClass('show')
	setTimeout(function () {
		$('#fpToastContainer3').removeClass('show')
	}, 3000)
}

var fpEmailPhase = 'idle'

function fpEmailStart(event) {
	event.stopPropagation()
	fpEmailPhase = 'email'
	$('#fpEmailInput').val('').attr('placeholder', 'Zadejte svůj e-mail').attr('type', 'email')
	$('#fpEmailStep .fp-login__odeslat').text('Odeslat kód')
	$('#fpEmailStep').prop('hidden', false)
	$('#fpEmailInput').focus()
}

function fpEmailSubmit(event) {
	event.preventDefault()
	if (fpEmailPhase === 'email') {
		var email = $('#fpEmailInput').val()
		$('#fpToastEmail').text(email)
		$('#fpToastContainer4').addClass('show')
		setTimeout(function () {
			$('#fpToastContainer4').removeClass('show')
		}, 3000)
		$('#fpEmailInput').val('').attr('placeholder', 'Zadejte kód z e-mailu').attr('type', 'text')
		$('#fpEmailStep .fp-login__odeslat').text('Přihlásit')
		fpEmailPhase = 'code'
	} else if (fpEmailPhase === 'code') {
		fpEmailPhase = 'idle'
		$('#fpEmailStep').prop('hidden', true)
		$('.fp-login__drop').removeClass('show').attr('aria-hidden', true)
		$('#fpLoginBtn').attr('aria-expanded', false)
		$('#fpMobLoginBackdrop').removeClass('open')
		fpDoLogin()
	}
}
